import React, { useState } from "react";
import { DailogBox } from "../../../../../components/Elements/DailogBox/DailogBox";
import { Select } from "antd";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";

const FilterLocationDeparment = ({ onOpen, onClose, onApply, initialStatus, initialType }) => {
  const [status, setStatus] = useState(initialStatus || null);
  const [type, setType] = useState(initialType || null);

  const statusOptions = [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
  ];

  const typeOptions = [
    { label: "Core", value: "Core" },
    { label: "Support", value: "Support" },
  ];

  return (
    <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="500px">
      {/* Heading */}
      <div>
        <h3 className="text-xl font-semibold">Filter</h3>
      </div>

      {/* Status Dropdown */}
      <div className="flex flex-col w-full mt-8">
        <label className="text-sm text-gray-600 mb-1">Status</label>
        <Select
          value={status}
          onChange={setStatus}
          placeholder="SELECT STATUS"
          className="text-lg font-light h-10"
          allowClear
        >
          {statusOptions.map((option) => (
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          ))}
        </Select>
      </div>

      {/* {isDepartment && (
        <div className="flex flex-col w-full mt-4">
          <label className="text-sm text-gray-600 mb-1">Department Type</label>
          <Select
            value={type}
            onChange={setType}
            placeholder="SELECT TYPE"
            className="text-lg font-light h-10"
            allowClear
          >
            {typeOptions.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </div>
      )} */}

      {/* Buttons */}
      <div className="flex justify-center gap-4 py-6">
        <CustomButton
          buttonType="primary"
          variant="cancel"
          buttonText="Cancel"
          className="text-sm px-6 py-2 rounded-lg"
          onClick={onClose}
        />

        <CustomButton
          buttonType="primary"
          variant="ok"
          buttonText="Apply"
          className="text-sm px-6 py-2 rounded-lg"
          onClick={() => {
            if (onApply) {
              onApply({ status, department_type: type });
            }
            onClose();
          }}
        />
      </div>
    </DailogBox>
  );
};

export default FilterLocationDeparment;
